import {
  confirmPasswordReset,
  sendPasswordResetEmail,
  verifyPasswordResetCode as firebaseVerifyPasswordResetCode,
} from 'firebase/auth';
import { auth } from '@/firebase';

async function sendResetPasswordEmail(email: string) {
  await sendPasswordResetEmail(auth, email);
}

async function resetPassword(code: string, password: string) {
  await confirmPasswordReset(auth, code, password);
}

async function verifyPasswordResetCode(code: string): Promise<string> {
  const email = await firebaseVerifyPasswordResetCode(auth, code);
  return email;
}

export default {
  sendResetPasswordEmail,
  resetPassword,
  verifyPasswordResetCode,
};
